/**
 * Get the document title to use in the document.
 *
 * @param {string} title The base title.
 *
 * @returns {string} The enriched document title.
 */

export const getDocumentTitle = title => title ? title + " – MyYoast" : "MyYoast";
